// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__90F5X","label":"styles_label__kiqFF"};